import React, { FC, memo } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { DateTimePeriod } from 'stores/events/events-store';
import TailwindPeriodInput from 'widgets/form/period-input-tw';
import './pause-periods-list.less';

interface TailwindEventPausePeriodProps extends WithTranslation {
  onEditMode: boolean;
  pausePeriods?: DateTimePeriod[];
  onChange?: (period: DateTimePeriod[]) => void;
  hideIcon?: boolean;
  btnWithItems?: boolean;
  className?: string;
  startDate?: string;
  endDate?: string;
}
const TailwindEventPausePeriodList: FC<TailwindEventPausePeriodProps> = props => {
  const { onEditMode, onChange, t, pausePeriods, btnWithItems, startDate, endDate } = props;
  const handleOnRemovePausePeriod = (index: number) => {
    onChange(pausePeriods.filter((_, i) => i !== index));
  };

  const handlePeriodChange = (period: DateTimePeriod, index: number) => {
    const periods = [...pausePeriods];
    periods[index] = period;
    onChange(periods);
  };

  const handleOnAddPausePeriod = (): void => {
    const emptyPeriod: DateTimePeriod = { from: null, to: null };
    const periods = [...pausePeriods, emptyPeriod];
    onChange(periods);
  };

  return (
    <>
      {/* {!hideIcon && <FontAwesomeIcon className="form__header__row-icon" icon={faPauseCircle} />} */}
      {!btnWithItems && (
        <button
          disabled={!onEditMode}
          onClick={handleOnAddPausePeriod}
          className={`w-full ${!onEditMode ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
        >
          {t('Add Pause Period')}
        </button>
      )}
      <div className="pause-period__items">
        {btnWithItems && (
          <button
            disabled={!onEditMode}
            onClick={handleOnAddPausePeriod}
            className={`w-full ${!onEditMode ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
          >
            {t('Add Pause Period')}
          </button>
        )}
        {(pausePeriods || []).map((period, index) => (
          <div key={`${period.from}-${index}-${period.to}`} className="bg-gray-50 rounded shadow p-4 mb-4">
            <div className="flex items-center gap-4">
              <div className="flex-1">
                <TailwindPeriodInput
                  id={`pause-period-${period.from}-${index}-${period.to}`}
                  readOnly={!onEditMode}
                  value={period}
                  onChange={value => handlePeriodChange(value, index)}
                  defaultStartDate={startDate}
                  defaultEndDate={endDate}
                />
              </div>
              {onEditMode && pausePeriods.length > 0 && (
                <div onClick={inst => handleOnRemovePausePeriod(index)}>
                  <svg
                    className="w-6 h-6 text-red-500 cursor-pointer flex-shrink-0"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    onClick={() => handleOnRemovePausePeriod(index)}
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 15v3c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1v-3M3 15V6c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.5061-7.4939L12 10m0 0 1.5061-1.50614M12 10l1.5061 1.5061M12 10l-1.5061-1.50614"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
TailwindEventPausePeriodList.defaultProps = { hideIcon: false, btnWithItems: false };
export default withTranslation()(memo(TailwindEventPausePeriodList));
